import { createContext, useContext, useEffect, useState } from 'react';

// starea platformei (deschisa / inchisa), citita de pe server (DATA_INCHIDERE din .env-ul serverului)
export const ContextPlatforma = createContext({ inchisa: false, dataInchidere: null });

export const usePlatforma = () => useContext(ContextPlatforma);

// se reverifica periodic si la revenirea in tab, ca o pagina lasata deschisa
// peste ora inchiderii sa se actualizeze singura
const INTERVAL_VERIFICARE = 5 * 60 * 1000;

export function ProviderPlatforma({ children }) {
  const [stare, setStare] = useState({ inchisa: false, dataInchidere: null });

  useEffect(() => {
    const verifica = () =>
      fetch(`${process.env.REACT_APP_SERVER}platforma`)
        .then((res) => res.json())
        .then((date) => setStare({
          inchisa: !!date.inchisa,
          dataInchidere: date.dataInchidere ? new Date(date.dataInchidere) : null,
        }))
        .catch(() => {});
    verifica();
    const interval = setInterval(verifica, INTERVAL_VERIFICARE);
    window.addEventListener('focus', verifica);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', verifica);
    };
  }, []);

  return <ContextPlatforma.Provider value={stare}>{children}</ContextPlatforma.Provider>;
}

const formatRo = (data) =>
  data.toLocaleDateString('ro-RO', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Bucharest' });

// ziua inchiderii, ex. „6 noiembrie 2026”
export const ziuaInchiderii = (dataInchidere) => (dataInchidere ? formatRo(dataInchidere) : null);

// ultima zi in care platforma e deschisa: inchiderea la 6 nov. 00:00 => „5 noiembrie 2026”
export const ultimaZiDeschisa = (dataInchidere) =>
  dataInchidere ? formatRo(new Date(dataInchidere.getTime() - 1)) : null;
